import React, { useCallback, useEffect, useMemo, useState } from 'react';

import { useHistory, useParams } from 'react-router-dom';
// import { collection, query, where, getDocs } from 'firebase/firestore';
import App from '~/layouts/App';
import AddProduct from './AddProduct';

import IProduct from '~/interfaces/IProduct';
import getCurrencyFormatted from '~/utils/getCurrencyFormatted';
import { useSettings } from '~/hooks/settings';

// import { DB } from '~/services/firebase';
import { useProducts } from '~/hooks/products';
import { useCategories } from '~/hooks/categories';

interface Params {
  id: string;
  category: string;
}

const HomeCategory: React.FC = () => {
  const params = useParams<Params>();
  const history = useHistory();
  const { category } = params;
  const { company } = useSettings();
  const {
    products: ctxProducts,
    loadProducts,
    isInitialized: productInitialized,
  } = useProducts();
  const { loadCategories, loadComplements, complements, isInitialized } =
    useCategories();
  const [product, setProduct] = useState({} as IProduct);
  const [products, setProducts] = useState<IProduct[]>([]);
  const [loading] = useState(false);
  const [search, setSearch] = useState('');
  const [categoryName, setCategoryName] = useState('');

  const filtered = useMemo(() => {
    const filter = products.filter(item =>
      item.name.toLocaleLowerCase().includes(search.toLocaleLowerCase()),
    );

    filter.sort((a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0));

    return filter;
  }, [products, search]);

  const getProductsFromCategory = useCallback(() => {
    const productsFromCategory = ctxProducts.filter(
      item => item.category.uid === category,
    );

    if (productsFromCategory.length > 0) {
      setProducts(productsFromCategory);
      setCategoryName(productsFromCategory[0].category.name);
    }
  }, [ctxProducts, category]);

  useEffect(() => {
    getProductsFromCategory();
  }, [getProductsFromCategory]);

  const handleLoadComplements = useCallback(async () => {
    if (company.uid && complements.length === 0) loadComplements(company.uid);
  }, [company, loadComplements]);

  const handleLoadCategories = useCallback(async () => {
    if (company.uid) loadCategories(company.uid);
  }, [company, loadCategories]);

  const handleLoadProducts = useCallback(async () => {
    if (company.uid) {
      await loadProducts();
    }
  }, [company, loadProducts]);

  useEffect(() => {
    if (!productInitialized) handleLoadProducts();
  }, [handleLoadProducts, productInitialized]);

  useEffect(() => {
    if (!isInitialized) handleLoadCategories();
  }, [handleLoadCategories, isInitialized]);

  useEffect(() => {
    if (!isInitialized) handleLoadComplements();
  }, [handleLoadComplements, isInitialized]);

  // const handleLoadProducts = useCallback(async () => {
  //   if (company.uid && category) {
  //     setLoading(true);

  //     const productsRef = collection(DB, 'products');
  //     const q = query(
  //       productsRef,
  //       where('category.uid', '==', category),
  //       where('company_id', '==', company.uid),
  //       where('status', '==', true),
  //     );
  //     const querySnapshot = await getDocs(q);

  //     const items: IProduct[] = [];

  //     querySnapshot.docs.forEach(item => {
  //       const parseItem = {
  //         ...item.data(),
  //         uid: item.id,
  //       } as IProduct;

  //       items.push(parseItem);
  //     });

  //     if (items.length > 0) {
  //       setCategoryName(items[0].category.name);
  //     }

  //     items.sort((a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0));

  //     setProducts(items);

  //     setTimeout(() => setLoading(false), 500);
  //   }
  // }, [company, category]);

  // useEffect(() => {
  //   if (company.uid) loadBanners(company.uid);
  // }, [company, loadBanners]);

  // useEffect(() => {
  //   handleLoadProducts();
  // }, [handleLoadProducts]);

  // useEffect(() => {
  //   if (filtered && filtered.length > 0) {
  //     swipe = new global.Swiper('.products', {
  //       slidesPerView: 2,
  //       spaceBetween: 8,
  //       breakpoints: {
  //         992: {
  //           slidesPerView: 6,
  //           spaceBetween: 8,
  //         },
  //       },
  //     });
  //   } else {
  //     setLoading(true);
  //   }
  // }, [filtered]);

  // useEffect(() => {
  //   if (categories && categories.length > 0) {
  //     swipe = new global.Swiper('.categoriesswiper', {
  //       slidesPerView: 4,
  //       spaceBetween: 8,
  //       breakpoints: {
  //         992: {
  //           slidesPerView: 10,
  //           spaceBetween: 8,
  //         },
  //       },
  //     });

  //     swipe.toString();
  //   }
  // }, [categories]);

  // const categoriesIds = useMemo(() => {
  //   return categories.map(item => item.uid);
  // }, [categories]);

  const handleClickProduct = useCallback((item: IProduct) => {
    setProduct(item);
  }, []);

  const handleGoBack = useCallback(() => {
    history.goBack();
  }, [history]);

  return (
    <App showHeader={false} loading={loading}>
      <button
        type="button"
        onClick={handleGoBack}
        className="link mt-3"
        style={{
          color: company.app_color,
          width: 75,
          padding: 0,
          background: 'transparent',
          border: 0,
        }}
      >
        <i className="bi bi-arrow-left" />
        {' Voltar'}
      </button>

      <div className="row mb-4 mt-4">
        <div className="col">
          <div
            className="form-floating"
            style={{
              border: '1px solid rgba(0, 0, 0, 0.125)',
              borderRadius: 8,
            }}
          >
            <input
              type="text"
              className="form-control"
              id="search"
              placeholder="Buscar..."
              onChange={event => {
                setSearch(event.target.value);
              }}
            />
            <label htmlFor="search">Buscar...</label>
            <button
              type="button"
              className="btn btn-link tooltip-btn d-block text-color-theme"
              style={{ color: company.app_color }}
            >
              <i className="bi bi-search" />
            </button>
          </div>
        </div>
        {/* <div className="col-auto">
          <button
            type="button"
            className="btn btn-lg btn-theme shadow-sm filter-btn"
          >
            <i className="bi bi-search size-22" />
          </button>
        </div> */}
      </div>

      {/* <div
        id="categories"
        className="swiper-container categoriesswiper sticky mb-3 mt-3"
      >
        <div className="swiper-wrapper">
          {categories.map(category => (
            <div
              className="swiper-slide"
              key={category.uid}
              onClick={() => handleClickCategory(category.uid)}
            >
              <div className="card shadow-sm">
                <div className="card-body">
                  <img src={category.image || placeholder} alt="categoria" />
                </div>
              </div>
              <p className="categoryname">{category.name}</p>
            </div>
          ))}
        </div>
      </div> */}

      <div>
        <div className="row mb-3">
          <div className="col">
            <h5 className="mb-0">{categoryName}</h5>
          </div>
          {/* <div className="col-auto">
              <Link
                to="#_"
                className="link"
                style={{ color: company.app_color }}
              >
                {'ver mais '}
                <i className="bi bi-arrow-right" />
              </Link>
            </div> */}
        </div>

        <div className="products">
          <div className="row">
            {filtered.map(item => (
              <div
                className="col-md-2 col-6"
                key={item.uid}
                onClick={() => handleClickProduct(item)}
              >
                <div className="card shadow-sm product mb-4">
                  <figure
                    className="text-center mb-0 bg-light-warning product-home"
                    style={{
                      background: `${company.app_color}60`,
                    }}
                  >
                    {/* <div
                        style={{
                          background: `url('${item.image || company.image}')`,
                        }}
                      /> */}
                    <img
                      src={item.image || company.image}
                      alt={item.name}
                      className="custom-img"
                    />
                  </figure>
                  <div className="card-body">
                    {/* <p className="mb-1">
                      <small className="text-opac">Fresh</small>
                      <small className="float-end">
                        <span className="text-opac">4.5</span>{' '}
                        <i className="bi bi-star-fill text-warning" />
                      </small>
                    </p> */}

                    <h6
                      className="text-color-theme custom-text"
                      style={{ color: company.app_color }}
                    >
                      {item.name}
                    </h6>

                    <div className="row">
                      <div className="col">
                        {parseFloat(item.value) > 0 && (
                          <p className="mb-0">
                            {getCurrencyFormatted(parseFloat(item.value))}
                          </p>
                        )}

                        {parseFloat(item.value) === 0 && (
                          <p className="mb-0" style={{ fontSize: 12 }}>
                            {item.description}
                          </p>
                        )}
                      </div>
                      {/* <div className="col-auto">
                          <div className="counter-number">
                            <button
                              type="button"
                              className="btn btn-sm avatar avatar-30 p-0 rounded-circle"
                            >
                              <i className="bi bi-dash size-22" />
                            </button>
                            <span>1</span>
                            <button
                              type="button"
                              className="btn btn-sm avatar avatar-30 p-0 rounded-circle"
                            >
                              <i className="bi bi-plus size-22" />
                            </button>
                          </div>
                        </div> */}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <AddProduct
        product={product}
        onClose={() => setProduct({} as IProduct)}
      />
    </App>
  );
};

export default HomeCategory;
